import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {getAccountStatement, closePopup } from '../../Modal/action';
import RadioButton from '../../RadioButton';
import './style.scss';


@connect((state)=>({
    accountStatement:state.modal.accountStatement,
}),(dispatch)=>({
    ...bindActionCreators({closePopup,getAccountStatement},dispatch),
}))
export default class AccountStatement extends Component {

    constructor(props){
        super(props);
        this.state={
            language:''
        }
    }
    componentDidMount(){
        const {getAccountStatement}=this.props;
        getAccountStatement();
    }
    handleChange  = (name,value) => {
        this.setState({ 'language': value });
    };
    handleClick  = () => {
        let { language }=this.state;
        this.props.closePopup();
        // if(language==0  && __CLIENT__){
        //     let url;
        //     {/*setting node env for production*/}
        //     if(process.env.NODE_ENV != 'production' && process.env.NODE_ENV != 'beta' ){
        //        url =  `http://uat-investor.tothenew.net/validate-folio`
        //     }
        //     else{
        //         url='https://investor-web.hdfcfund.com/validate-folio'
        //     }
        //     window.open(url, 'newwindow', 'width=1000,height=600');
        // }
        // else
        if (__CLIENT__ ){
            window.open(`https://investor-web.hdfcfund.com`, 'newwindow',
                'width=1000,height=600');
        }
    };
    render() {
        let { closePopup, modalData, accountStatement} = this.props;
        const {language}=this.state;
        return (
            <div className="modal-body clearfix row">
                <p className="subtitle">{ accountStatement && accountStatement.top}</p>
                {accountStatement && accountStatement.lang &&
                    <RadioButton label="Please select the preferred language:" objectType={true} onChange={this.handleChange} value={language}
                                 radioClass="col-6" name="language" options={accountStatement.lang}/>
                }
                { accountStatement && accountStatement.content &&
                <div dangerouslySetInnerHTML={{ __html:accountStatement.content }}/>}
                <button  disabled={language==""? true: false}  className='rounded-pink-rect' type='submit'
                onClick={this.handleClick}>
                    I agree
                </button>
            </div>
        );
    }
}

